import { NO_EPG_ID } from '../index.h'

export { inRange, rangeCovered, rangePosition } from './ranges'

// `channelEpgId` getter
export const channelEpgId = <T extends { channelEpgId?: string }>(
  obj: T
): string => obj.channelEpgId ?? NO_EPG_ID
